import routerOptions0 from "/app/node_modules/.pnpm/nuxt@3.15.4_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@22.10.7_db0@0.3.2_es_43aae2a113bed0230e3f586d982cb340/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}